module.exports = __webpack_public_path__ + "static/media/mashima.37d7372a.png";